'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);


var _RealtorQuestionPackage = require('./RealtorQuestionPackage.scss');var styles = _interopRequireWildcard(_RealtorQuestionPackage);
var _packagesData = require('../../packagesData');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} // styles

var RealtorQuestionPackage = function RealtorQuestionPackage(props) {
  var handleBuy = function handleBuy() {var
    packageInstance = props.packageInstance,handleChoosePackage = props.handleChoosePackage;
    handleChoosePackage(packageInstance);
  };

  var renderTopBlock = function renderTopBlock() {var _props$packageInstanc =
    props.packageInstance,packageInstance = _props$packageInstanc === undefined ? {} : _props$packageInstanc;
    var count = (0, _get2.default)(packageInstance, 'period.' + _packagesData.periods.FOREVER + '.quantity', 0);
    var buyMoreQuestionsTranslate = props.translate('buyMoreQuestions');

    return (
      _react2.default.createElement('div', { className: styles.countWrapper },
        _react2.default.createElement('h4', { className: styles.count }, count),
        _react2.default.createElement('p', { className: styles.subtitle }, count === 1 ?
          buyMoreQuestionsTranslate('lead') :
          buyMoreQuestionsTranslate('leads'))));


  };

  var renderPriceBlock = function renderPriceBlock() {var _props$packageInstanc2 =
    props.packageInstance,packageInstance = _props$packageInstanc2 === undefined ? {} : _props$packageInstanc2;
    var price = (0, _get2.default)(packageInstance, 'period.' + _packagesData.periods.FOREVER + '.price', 0);
    var oldPrice = (0, _get2.default)(packageInstance, 'period.' + _packagesData.periods.FOREVER + '.oldPrice', 0);
    var buyMoreQuestionsTranslate = props.translate('buyMoreQuestions');

    return (
      _react2.default.createElement('div', { className: styles.priceBlock },
        _react2.default.createElement('h4', { className: styles.priceTitle }, buyMoreQuestionsTranslate('cardPrice').toUpperCase()),
        !!oldPrice &&
        _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.oldPrice) }, '\u20AA',
          oldPrice),


        _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.price) }, '\u20AA',
          price)));



  };

  return (
    _react2.default.createElement('div', { className: styles.questionPackageWrapper },
      renderTopBlock(),
      renderPriceBlock(),
      _react2.default.createElement('button', {
          className: styles.actionButton,
          onClick: handleBuy },

        props.translate('buyMoreQuestions', 'cardButtonText'))));



};

RealtorQuestionPackage.propTypes = {
  locale: _propTypes2.default.string,
  isRtl: _propTypes2.default.bool,
  packageInstance: _propTypes2.default.object,
  translate: _propTypes2.default.func,
  handleChoosePackage: _propTypes2.default.func };exports.default =


RealtorQuestionPackage;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/RealtorQuestionPackage/RealtorQuestionPackage.js
// module id = 2895
// module chunks = 0